import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Text,
  Textarea,
} from "@chakra-ui/react";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import { sendBulkCustomMessageToPhonesRequest } from "../../../modules/admin-modules/asquera-practice/Actions";

const parsePhones = (phonesText) =>
  phonesText
    .split(/\r?\n/)
    .map((phone) => phone.trim())
    .filter(Boolean);

const BulkMessageToPhones = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const userLoading = useSelector((state) => state.user.isLoading);
  const isSending = useSelector(
    (state) => state.asqueraPractice.sendBulkMessageLoading
  );

  const [phonesText, setPhonesText] = useState("");
  const [message, setMessage] = useState("");

  const phones = parsePhones(phonesText);

  const isSuperAdmin =
    user?.role &&
    Array.isArray(user.role) &&
    user.role[0]?.name === "Super Admin";

  React.useEffect(() => {
    if (userLoading) return;
    if (user?.role && Array.isArray(user.role) && !isSuperAdmin) {
      navigate("/dashboard/students");
    }
  }, [user, userLoading, isSuperAdmin, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phones.length === 0 || !message.trim()) return;

    dispatch(
      sendBulkCustomMessageToPhonesRequest(
        {
          phones,
          message: message.trim(),
        },
        () => {
          setPhonesText("");
          setMessage("");
        }
      )
    );
  };

  if (userLoading || !user?.role) return null;
  if (!isSuperAdmin) return null;

  return (
    <Layout>
      <Box minHeight="400px">
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          zIndex="10000000"
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            رسالة مخصصة للهواتف / Bulk Custom Message to Phones
          </Text>
          <LogoutMenu />
        </Flex>

        <Box
          as="form"
          onSubmit={handleSubmit}
          maxW="700px"
          p={6}
          bg="white"
          borderRadius="lg"
          boxShadow="md"
          border="1px solid"
          borderColor="gray.200"
        >
          <FormControl isRequired mb={4}>
            <FormLabel>أرقام الهواتف / Phones</FormLabel>
            <Textarea
              value={phonesText}
              onChange={(e) => setPhonesText(e.target.value)}
              placeholder={"01012345678\n01112345678\n01212345678"}
              rows={10}
              size="lg"
              dir="ltr"
            />
            <Text fontSize="sm" color="gray.600" mt={2}>
              Paste one phone number per line. {phones.length} phone(s)
              detected.
            </Text>
          </FormControl>

          <FormControl isRequired mb={6}>
            <FormLabel>الرسالة / Message</FormLabel>
            <Textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Enter message..."
              rows={6}
              size="lg"
            />
          </FormControl>

          <Button
            type="submit"
            colorScheme="orange"
            color="white"
            isLoading={isSending}
            loadingText="جاري الإرسال..."
            isDisabled={phones.length === 0 || !message.trim()}
          >
            إرسال / Send
          </Button>
        </Box>
      </Box>
    </Layout>
  );
};

export default BulkMessageToPhones;
